import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';

declare const Stripe: any;

@Component({
	standalone: true,
	selector: 'booking-checkout-status',
	templateUrl: './booking-checkout-status.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export default class BookingCheckoutStatusView implements OnInit {
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			var status: any = this.angularRoutingHelperService.getCurrentRouteParam('status');
			var instantBookingId: any = this.angularRoutingHelperService.getQueryParam('bookingInstantRequestId') || this.angularRoutingHelperService.getCurrentRouteParam('bookingInstantRequestId');
			var bookingOfferId: any = this.angularRoutingHelperService.getQueryParam('bookingOfferId') || this.angularRoutingHelperService.getCurrentRouteParam('bookingOfferId');
			var allowedStatuses: Array<any> = ['success', 'error'];
			
			if (instantBookingId) {
				this.angularRoutingHelperService.clearQueryParamsDirty()
				this.angularRoutingHelperService.setPath('/booking/instant/' + instantBookingId + '/pending', false, true);
			} else if (bookingOfferId) {
				this.vm.bookingOfferId = bookingOfferId;
				if (allowedStatuses.indexOf(status) === -1) {
					this.angularRoutingHelperService.setPath('/', false, true);
				} else {
					this.vm.status = status;
				}
			} else {
				if (allowedStatuses.indexOf(status) === -1) {
					this.angularRoutingHelperService.setPath('/', false, true);
				} else {
					this.vm.status = status;
				}
			}
		});
	}
	
}
